export var WebPaymentMethodType;
(function(WebPaymentMethodType) {
    WebPaymentMethodType[/**
     * A method that redirects to a payment provider's page to process payments.
     */ "Redirect"] = "Redirect";
    WebPaymentMethodType[/**
     * A method that is rendered within the hosting website.
     */ "Embedded"] = "Embedded";
})(WebPaymentMethodType || (WebPaymentMethodType = {}));

//# sourceMappingURL=web-payment-method-type.js.map